import { BenefitsSection } from "../../models/page-builder/benefit.modal";

// Define mock data

export const MOCK_BENEFITS_SECTION: BenefitsSection = {
  type: "benefits",
  content: {
    headings: {
      preTitle: "Join 4,000+ users growing with OnlineCourseHost",
      preTitleColor: "#000",
      title: "Join 4,000+ users growing with OnlineCourseHost",
      titleColor: "#000",
      subTitle:
        "Start your free trial today and take your place in our growing community every day",
      subTitleColor: "#666",
    },
    benefits: [
      {
        title: "Send Bulk Emails",
        titleColor: "#666",
        subTitle:
          "Send bulk emails to your students, instructors, or any other group of users.",
        subTitleColor: "#666",
        button: {
          type: "link",
          linkName: "Learn Less",
          linkUrl: "https://example.com",
          linkColor: "#3366FF",
          btnBgColor: "#FF6633",
          btnBorderColor: "#FF6633",
        },
        image: {
          type: "image",
          originalFileName: "background-original.jpg",
          uploadFileName: "background.jpg",
          url: "https://picsum.photos/3000/1600",
          imageSettings: {
            overlayWithBackground: true,
            opacity: 0.1,
            blending: "normal",
            blur: 2,
            grayScale: 10,
            contrast: 100,
          },
        },
      },
      {
        title: "Send Bulk Messages",
        titleColor: "#666",
        subTitle:
          "Send bulk emails to your students, instructors, or any other group of players.",
        subTitleColor: "#666",
        button: {
          type: "button",
          linkName: "Learn Less",
          linkUrl: "https://example.com",
          linkColor: "#3366FF",
          btnBgColor: "#FF6633",
          btnBorderColor: "#000",
        },
        image: {
          type: "image",
          originalFileName: "background-original.jpg",
          uploadFileName: "background.jpg",
          url: "https://picsum.photos/3000/1600",
          imageSettings: {
            overlayWithBackground: true,
            opacity: 0.1,
            blending: "normal",
            blur: 2,
            grayScale: 10,
            contrast: 100,
          },
        },
      },
    ],
    media: {
      mediaFileUrl: {
        type: "image",
        originalFileName: "background-original.jpg",
        uploadFileName: "background.jpg",
        url: "https://picsum.photos/1406/400",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.1,
          blending: "normal",
          blur: 2,
          grayScale: 10,
          contrast: 100,
        },
      },
    },
  },
  design: {
    layout: "card",
    headingAlignment: "center",
    mediaAlignment: "leftRight",
    appearance: {
      BgColor: "#6F8FAF",
      cardBgColor: "#fff",
      backgroundImageUrl: {
        type: "image",
        originalFileName: "background-original.jpg",
        uploadFileName: "background.jpg",
        url: "https://picsum.photos/3000/1600",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.1,
          blending: "normal",
          blur: 2,
          grayScale: 10,
          contrast: 100,
        },
      },
    },
  },
};
